import React from 'react';
import LogoA from '../../../assets/A.svg';

interface LoaderProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
}

export const Loader: React.FC<LoaderProps> = ({ 
  size = 'medium', 
  showText = true,
  className = '' 
}) => {
  const sizeClasses = {
    small: 'w-8 h-8',
    medium: 'w-16 h-16',
    large: 'w-24 h-24'
  };

  const textSizeClasses = {
    small: 'text-body',
    medium: 'text-heading-3',
    large: 'text-heading-2'
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div className={`relative ${sizeClasses[size]} animate-pulse`}>
        <img
          src={LogoA}
          alt="Qbank by Aksanio"
          className="w-full h-full"
          style={{ filter: 'brightness(0) saturate(100%) invert(41%) sepia(84%) saturate(1144%) hue-rotate(195deg) brightness(91%) contrast(90%)' }}
        />
        <div className="absolute inset-0 animate-ping">
          <img 
            src={LogoA} 
            alt="" 
            className="w-full h-full opacity-20"
            style={{ filter: 'brightness(0) saturate(100%) invert(41%) sepia(84%) saturate(1144%) hue-rotate(195deg) brightness(91%) contrast(90%)' }}
          />
        </div>
      </div>
      {showText && (
        <p className={`mt-4 font-heading-3 text-brand-600 dark:text-brand-400 ${textSizeClasses[size]}`}>
          Aksanio
        </p>
      )}
    </div>
  );
};

// Full page loader component
export const PageLoader: React.FC = () => {
  return (
    <div className="fixed inset-0 bg-white dark:bg-neutral-900 flex items-center justify-center z-50">
      <Loader size="large" />
    </div>
  );
};

// Inline loader component
export const InlineLoader: React.FC<{ text?: string }> = ({ text = 'Loading...' }) => {
  return (
    <div className="flex items-center gap-3">
      <Loader size="small" showText={false} />
      <span className="text-body text-subtext-color dark:text-neutral-400">{text}</span>
    </div>
  );
};